import { TKioskPlanningDropdownItem } from 'types/kiosk/TKioskStartRegistrationData';
import { currentTimeHHmm, isoToYmd, ymdToLocalDate } from 'utils/kiosk-date';

export const kioskStartPrefill = (
  planning: TKioskPlanningDropdownItem | undefined,
  allowRegistrationBeforePlannedStart: boolean,
  fallbackDate: Date,
  now: Date = new Date(),
): { date: Date; startWork: string } => {
  if (planning && !allowRegistrationBeforePlannedStart) {
    const planningDate = ymdToLocalDate(isoToYmd(planning.date));
    const [hh, mm] = planning.startWork.split(':').map(Number);
    const plannedStart = new Date(planningDate);
    plannedStart.setHours(hh || 0, mm || 0, 0, 0);

    const nowMinute = new Date(now);
    nowMinute.setSeconds(0, 0);

    if (nowMinute < plannedStart) {
      return { date: planningDate, startWork: planning.startWork };
    }
  }

  return { date: fallbackDate, startWork: currentTimeHHmm(now) };
};
